import type { FC } from 'react'
import type { ICmsOverview } from '@/pages/tad.ai/_components/FeatureCms/_types'

import { H2 } from '@/pages/tad.ai/_components/H2'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'


import { cls } from 'tagged-classnames-free';
export interface IOverviewProps {
  overview?: ICmsOverview | null
  className?: string
}

export const Overview: FC<IOverviewProps> = (props) => {
  const { overview, className } = props || {}
  if (!overview) {
    return null
  }
  const { title, desc } = overview

  return (
    <div className={cls`mx-auto max-w-[880px] ${className}`}>
      <div className='flex flex-col items-center text-center'>
        <span className={cls`i-cus--tad-logo-ico size-20`}></span>
        <H2>{title}</H2>
        <RichTextElement
          as='p'
          html={desc}
          className='text-f-text-secondary [&_a]:!text-f-primary pt-3 text-sm md:pt-4 md:text-base [&_a:hover]:underline'
        />
      </div>
    </div>
  )
}
